var _style, _path, _path2, _path3, _path4, _path5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCSharp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9A4993;}\n\t.st1{fill:#6A1577;}\n\t.st2{fill:#813084;}\n\t.st3{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M531.6,221.8c0-7.9-1.7-15.1-5.2-21.1c-3.4-6-8.5-10.9-15.2-14.8 c-56.2-32.4-112.5-64.8-168.7-97.2c-15.2-8.7-29.8-8.5-44.9,0.4c-22.4,13.1-134.5,77.4-167.8,96.8c-13.8,7.9-20.4,20.2-20.4,36 c0,65.2,0,130.5,0,195.7c0,7.8,1.7,14.7,4.9,20.7c3.4,6.1,8.6,11.3,15.5,15.4c33.4,19.4,145.4,83.5,167.8,96.8 c15.1,8.8,29.8,9.2,44.9,0.4c56.2-32.5,112.5-64.8,168.7-97.2c7-4,12.1-9.1,15.5-15.4c3.3-6,4.9-12.9,4.9-20.7 C531.6,417.4,531.6,286.9,531.6,221.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st1",
    d: "M321,318.9L114,438.1c3.4,6.1,8.6,11.3,15.5,15.4C163,472.8,275,537,297.3,550.3 c15.1,8.8,29.8,9.2,44.9,0.4c56.2-32.5,112.5-64.8,168.7-97.2c7-4,12.1-9.1,15.5-15.4L321,318.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st1",
    d: "M259.7,354.2c12.1,21.1,34.7,35.3,60.6,35.3c26.1,0,48.9-14.3,60.9-35.6L321,318.9L259.7,354.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st2",
    d: "M531.6,221.8c0-7.9-1.7-15.1-5.2-21.1L321,318.9l205.7,119.2c3.3-6,4.9-12.9,4.9-20.7 C531.6,417.4,531.6,286.9,531.6,221.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st3",
    d: "M381.3,353.8c-12,21.2-34.7,35.6-60.9,35.6c-26,0-48.7-14.2-60.6-35.3c-5.9-10.3-9.2-22-9.2-34.6 c0-38.6,31.2-69.9,69.9-69.9c25.8,0,48.3,14.1,60.4,34.9l61-35.1c-24.3-41.9-69.6-70.1-121.5-70.1c-77.5,0-140.2,62.8-140.2,140.2 c0,25.4,6.8,49.3,18.6,69.9c24.2,42,69.7,70.4,121.8,70.4c52.2,0,97.7-28.5,121.9-70.8L381.3,353.8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_32_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2_",
    x: 444.5,
    y: 286.4,
    className: "st3",
    width: 13.9,
    height: 67.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_30_",
    x: 475.3,
    y: 286.4,
    className: "st3",
    width: 13.9,
    height: 67.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_31_",
    x: 433.3,
    y: 297.7,
    className: "st3",
    width: 67.3,
    height: 13.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_23_",
    x: 433.3,
    y: 328.4,
    className: "st3",
    width: 67.3,
    height: 13.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCSharp);
export default __webpack_public_path__ + "static/media/c-sharp.073e07169f86a07f762856c38060cdbb.svg";
export { ForwardRef as ReactComponent };